export default {
  translations: {
    login: {
      welcomeTitle: 'Welcome',
      importantMessage: 'All chat conversations will be recorded and may be audited by MJV.',
      description: 'Please log in with your corporate account.',
      loginLabel: 'Login',
      loginPlaceholder: 'Enter your first.last name',
      loginPattern: 'Your [Login] must be between 3 and 260 characters',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      passwordPattern: 'Your [Password] must be between 5 and 300 characters',
      buttonMessageOk: 'ACCESS',
      buttonMessageWait: 'PLEASE WAIT...'
    },
    home: {
      textBreadcrumb: 'Getting Started with Iron!',
      welcomeMessage: 'Welcome to IRON',
      description: 'Chat with one of the agents and unleash the best on you in terms of capacity and creativity.',
      callToAction: 'Try one of our agents',
      agentAll: 'General',
      descriptionAgentAll: 'Get answers to your questions on a variety of topics, without the need for a specific focus in the conversation.',
      agentHistoryUser: 'User Stories',
      descriptionAgentHistoryUser: 'Use your specialist in user stories for your project.',
      agentPointFunction: 'Function Points',
      descriptionAgentPointFunction: 'Expert in calculating function points for your project.',
      agentBackLog: 'Backlog',
      descriptionAgentBackLog: 'Expert in creating backlogs for your project.',
      agentDev: 'Development',
      descriptionAgentDev: 'Expert in developing new features and maintaining your system.',
      agentCasesOfTests: 'Test Cases',
      descriptionAgentCasesOfTests: 'Expert in creating test scenarios for your project.',
      agentQA: 'QA',
      descriptionAgentQA: 'Expert in quality assurance and automated software testing.',
      agentVulnerabilities: 'Vulnerabilities',
      descriptionAgentVulnerabilities: 'Expert in fixing vulnerabilities in your system.',
      agentFortify: 'Fortify',
      descriptionAgentFortify: 'Expert in fixing vulnerabilities identified by Fortify.',
      agentSupport: 'Support',
      descriptionAgentSupport: 'Expert in providing support for your project.',
      agentSaude: 'Bradesco Saúde',
      descriptionAgentSaude: 'Expert in questions and answers about the Bradesco Saúde app.',
      buttonChat: 'Chat',
      agentQualys: 'Qualys',
      descriptionAgentQualys: 'Expert in fixing vulnerabilities identified by Qualys.',
    },
    menu: {
      iasSection: 'Agents',
      iaGeral: 'General',
      iaUserHistory: 'User Stories',
      iaPointFunction: 'Function Points',
      iaBacklog: 'Backlog',
      iaDev: 'Coding',
      iaTestCase: 'Test Cases',
      iaQA: 'Test Scripts',
      iaVulnerabilities: 'Vulnerabilities',
      iaFortify: 'Fortify',
      iaSupport: 'Support',
      iaSupportAbs: 'Bradesco Saúde',
      historySection: 'History',
      historyMessageSelect: 'Select an Agent.',
      historyNull: 'No history available.',
      dashboardSection: 'Usage Dashboard',
      panelAdminSection: 'Admin Panel',
      panelConfigSection: 'Settings',
      logout: 'Logout',
      iaAccessibility: 'Accessibility',
      iaQualys: 'Qualys',
    },
    chatsBreadcrumbs: {
      iaTitle: 'Artificial Agents',
      iaGeral: 'General',
      iaUserHistory: 'User Stories',
      iaPointFunction: 'Function Points',
      iaBacklog: 'Backlog',
      iaDev: 'Development (Dev)',
      iaTestCase: 'Test Cases',
      iaQa: 'QA',
      iaVulnerability: 'Vulnerabilities',
      iaFortify: 'Fortify',
      iaSupport: 'Support',
      iaAccessibility: 'Accessibility',
      iaSupportAbs: 'Bradesco Saúde Support App',
      iaQualys: 'Qualys',
      iaFunctionPoint: 'Function Point',
      details: 'Details',
    },
    chatWelcomeBlock: {
      title: 'How can I assist you?'
    },
    chatForms: {
      textAreaPlaceholder: 'Type a Message to Iron',
      selectDefault: 'Select...',
      continueButton: 'Continue generation'
    },
    chatThinking: {
      messages: [
        'Thinking...',
        'Analyzing your question...',
        'Consulting the knowledge base...',
        'Preparing the best answer...',
        'Connecting the dots...',
        'Almost there...'
      ]
    },
    iaDevModal: {
      title: 'Add your code here:',
      fileLabel: 'Upload code file',
      filePlaceholder: 'Click or drag a file here',
      fileSupport: 'Supports .js, .py, .java files, etc.',
      languageLabel: 'Select file language',
      languageUndefined: 'Undefined language',
      languageUndefinedMessage: 'Undefined language, some features may not work as expected.',
      buttonSend: 'Send',
      buttonCancel: 'Cancel',
    },
    overlayQA: {
      titleOverlay: 'Agent Settings',
      description: 'Select the options below to get a more accurate response from our agents.',
      title1: 'What type of test do you want to perform?',
      description1: 'Choose the type of test you want to perform. Options may include manual and automated tests.',
      ariaLabel1: 'Select test type',
      title2: 'What level of test do you want to perform?',
      description2: 'Define the level of the test you want to apply, which can vary from unit tests, integration, and end-to-end.',
      ariaLabel2: 'Select test level',
      title3: 'Which framework will be applied?',
      description3: 'Choose the framework you will use to perform the test. Options may include Cucumber, Cypress, Selenium, etc.',
      ariaLabel3: 'Select framework',
      title4: 'What programming language is used?',
      description4: 'Select the programming language you are using for the tests. Options may include Java, Python, JS, etc.',
      ariaLabel4: 'Select programming language',
      buttonSave: 'Save Settings',
      manual: 'Manual Tests',
      automated: 'Automated Tests',
      endToEnd: 'End-to-End',
      integrated: 'Integrations/Services',
      unit: 'Unit'
    },
    
    overlaySwagger: {
      titleOverlay: 'Project Settings',
      description: 'Fill in the fields below to create your project.',
      projectName: 'Project Name',
      projectNameInputText: 'Enter the project name',
      projectGroup: 'Group',
      projectGroupDescription: 'com.group',
      projectPackage: 'Package',
      projectPackageDescription: 'com.package',
      projectClient: 'Client',
      projectType: 'Project Type',
      springBootVersion: 'Spring Boot Version',
      developmentLang: 'Programming Language',
      javaVersion: 'Java Version',
      dependence: 'Dependencies',
      projectDescription: 'Description',
      projectDescriptionInput: 'Enter the project description',
      swaggerFile: 'Swagger File',
      saveBtn: 'Save',   
    },
    overlayVulnerabilities: {
      titleOverlay: 'Agent Settings',
      description: 'Select the options below to get a more accurate response from our agents.',
      title1: 'What type of vulnerability do you want to fix?',
      description1: 'Choose the type of error that your application needs to trigger.',
      ariaLabel1: 'Select error type',
      buttonSave: 'Save Settings',
      none: 'None',
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    },
    iaFortify: {
      detailsVulnerabilities: 'Vulnerability Details',
      category: 'Category',
      nameOfFile: 'File Name',
      numberOfLine: 'Line Number',
      path: 'Path',
      directory: 'Directory',
      csvFile: 'CSV File',
      selectDirectory: 'Select Directory',
      selectCSV: 'Select a CSV',
      processSheet: 'Process Spreadsheet',
      welcomeMessage: 'Welcome! Please select a directory and a CSV file to get started.',
      vulnerabilities: 'Vulnerabilities',
      openWithFortify: 'Open with Fortify',
      selected: 'Selected',
      notSelected: 'Not selected',
      lineNotSpecified: 'Line not specified',
      title: 'Add the Fortify report here:',
      fileLabel: 'Upload Fortify report',
      filePlaceholder: 'Click or drag a file here',
      fileSupport: 'Supports .xml files',
      buttonSend: 'Send',
      buttonCancel: 'Cancel',
      syncronized: 'Synchronized',
      notSyncronized: 'Not Synchronized',
      dirSelected: 'Directory Selected',
      dirUnfound: 'Expected Directory',
      paths: 'Paths',
      overlayMessage: 'Upon the vulnerability found, please fix the problem.'
    },
    iaQualys: {
      detailsVulnerabilities: 'Vulnerability Details',
      openWithQualys: 'Open with Qualys',
      selected: 'Selected',
      notSelected: 'Not selected',
      welcomeMessage: 'Welcome! Please select a CSV file to get started.',
      selectCSV: 'Select a CSV',
      processSheet: 'Process Spreadsheet',
      csvFile: 'CSV File',
      vulnerabilities: 'Vulnerabilities',
      ip: 'IP',
      title: 'Title',
      port: 'Port',
      action: 'Action',
      overlayMessage: 'Upon the vulnerability found, please fix the problem.'
    },
    chatNotFound: {
      mainTitle: 'Chat Not Found!',
      title: 'Chat Not Found 🤖',
      message: 'The page you were looking for was not found! Click the button below to return to the home page.',
      buttonMessage: 'Back to Home'
    },
    dashboardUsage: {
      all: 'All',
      tokensSpent: 'Tokens Spent',
      estimativeValue: 'Estimated Value',
      spentInTokens: 'Spent in Tokens',
      spentInTokensDolars: 'Spent in Tokens (Dollars)',
      interactions: 'Interactions',
      interactionsByContexts: 'Interactions by Contexts',
    },
    adminPanel: {
      breadcrumb: 'Global Admin Panel',
      title: 'Admin Panel 🔒',
      description: 'Create, modify, and delete user permissions accessing the platform!',
      buttonCreateUser: 'Create User',
      username: 'Username',
      typeUser: 'User Role',
      permission: 'User Permission',
      actions: 'Actions',
      newUser: 'New User',
      close: 'Close',
      usersNotFound: 'No users found.',
      nameSurname: 'First.Last',
      updateUser: 'Update User',
      editUser: 'Edit User',
    },
    profilePanel: {
      breadcrumb: 'Profile Settings',
      myData: 'My Data',
      loginLabel: 'Login',
      positionLabel: 'Position',
      createdAtLabel: 'Registration Date',
      trialPeriodLabel: 'Trial Period (days)',
      trialPeriodRemainingDaysLabel: 'Remaining Trial Period (days)',
      trialRemainingTokensLabel: 'Remaining Tokens',
      spentTokensLabel: 'Spent Tokens',
      save: 'Save Changes',
      support: 'Support',
      descriptionSupport: 'If you have any questions, please contact Iron support at the email below: ',
      idioms: "Select a Language: ",
      ptBr: "Portuguese of Brazil (pt-BR)",
      enUs: "English (en-Us)",
      es: "Spanish (es)",
      cannotChangeYourOwnUser: 'You cannot change the permissions of your own user.',
      error: 'Error!',
    },
    FortifyFileInputErrors: {
      notSupported: 'Unsupported file type! Please choose a .csv, .xlsx, .json, .txt, .docx, .doc, .pdf or .feature file',
      uploadFile: 'Error uploading the file.',
      error: 'Error!',
    },
    downloadDocumentMessage: {
      loading: 'Building document...',
      success: 'Download document'
    },
    downloadSheetMessage: {
      loading: 'Building spreadsheet...',
      success: 'Download Sheet'
    },
    overlayAccessibility: {
      titleOverlay: 'Accessibility Agent Settings',
      description: 'Specialist in providing accessibility to your project.',
      modalTitleUrlParser: 'Get HTML from a URL',
      modalDescriptionUrlParser: 'I will access the requested website and analyze its HTML.',
      buttonOpenUrlParser: 'Open URL Extractor',
      modalTitleAccessibility: 'Upload or Paste Code',
      modalDescriptionAccessibility: 'You can upload or paste your code to be analyzed.',
      buttonOpenAccessibility: 'Insert HTML Code',
    },
    accessibilityModalFile: {
      title: 'Upload HTML Code',
      fileLabel: 'Upload the code file to be analyzed',
      fileLabelHint: 'Click or drag a file here to upload.',
      sendCode: 'Send Code',
      cancelBtn: 'Cancel',
      characterLimit: "The content has more than 250,000 characters.",
    },
    accessibilityModalUrl: {
      title: 'Analyze URL',
      placeholder: 'Enter the website URL to extract the HTML',
      analyse: 'Extract HTML',
      sendCode: 'Send Code',
      cancelBtn: 'Cancel',
      loading: 'Please wait...',
      error: 'Try again by adding http:// or https:// at the beginning of the URL.',
      characterLimit: "The content has more than 250,000 characters.",
    },
    agents: {
      geral: {
        name: "General",
        description:
          "I am a Language Model developed by MJV Technology & Innovation, part of the AI system known as Iron. My goal is to assist MJV employees in a wide range of topics, providing informative and contextually relevant responses. I am here to discuss and provide information on technology, science, art, general knowledge, and other subjects that may be useful in your professional daily life.",
      },
      historiaDeUsuario: {
        name: "User Story",
        description:
          "I am a specialist agent in business analysis, part of the Iron system developed by 'MJV Technology & Innovation'. I am here to help you in the creation and detailing of user stories for web and mobile software, following Agile practices, Scrum, Kanban, and human-centered design.",
      },
      pontoDeFuncao: {
        name: "Function Point",
        description:
          "I am a specialist agent in Function Point Analysis (FPA), part of the AI system developed by 'MJV Technology & Innovation'. My focus is to correctly classify the functions of a system as Elementary Processes (EP) or Data, strictly following the established rules and guidelines.",
      },
      backlog: {
        name: "Backlog",
        description:
          "I am part of Iron, an AI system developed by 'MJV Technology & Innovation'. Specifically, I am a specialist agent in transforming software development stories into epics, stories, tasks, and subtasks to create and structure the backlog of software projects or products. My goal is to ensure that each backlog item is well-defined, clear, and executable by the development team, contributing to the project's success.",
      },
      dev: {
        name: "Dev",
        description:
          "I am a specialist agent in software development at MJV Technology & Innovation. I am here to help you address and solve issues related to software development, applying best programming practices such as separation of concerns, error handling, SOLID principles, and other recommended practices.",
      },
      casosDeTestes: {
        name: "Test Cases",
        description:
          "I am an agent specialized in software testing, part of the Iron AI system developed by MJV Technology & Innovation. I am here to assist in the creation, planning, execution, and documentation of detailed test cases to ensure the quality and functionality of software systems.",
      },
      qa: {
        name: "QA",
        description:
          "I am a specialist agent in QA, part of the AI system developed by MJV Technology & Innovation, focused on ensuring software quality. My role is to help conceive and implement testing strategies, especially automated ones, to ensure that applications work as expected.",
      },
      vulnerabilidade: {
        name: "Vulnerability",
        description:
          "I am an agent specialized in software security, part of the AI system known as Iron, developed by 'MJV Technology & Innovation'. My role is to help you identify, fix, and prevent errors and vulnerabilities in your software, ensuring that your code is secure, robust, and reliable.",
      },
      fortify: {
        name: "Fortify",
        description:
          "I am an agent specialized in software security, part of the AI system known as Iron, developed by 'MJV Technology & Innovation'. My role is to analyze source code folders for security vulnerabilities, providing detailed information on how to fix them and ensure your software is secure and reliable.",
      },
      support: {
        name: "Support",
        description:
          "I am an artificial intelligence agent specialized in Systems Support. My main function is to assist in the analysis and resolution of incidents in software systems, using a history of previous incidents and best technical support practices.",
      },
      acessibilidade: {
        name: "Accessibilities",
        description:
          "I am an agent specialized in software accessibility, part of the AI system known as Iron, developed by 'MJV Technology & Innovation'. My goal is to help you make your software accessible to all users, including people with visual, auditory, motor, and cognitive disabilities, following the Web Content Accessibility Guidelines (WCAG).",
      },
      bradescoSaude: {
        name: "Bradesco Saúde",
        description:
          "I am a specialist agent in Frequently Asked Questions (FAQ) systems focused on the Bradesco Saúde App. My goal is to help you find accurate and up-to-date answers to your questions, using a knowledge base that supports various file formats like Docx, XLS, XLSX, and TXT. If you need any assistance related to access issues, registration, ID card, Idwall, reimbursement, or token in the Bradesco Saúde App, I'm here to help!",
      },
      qualys: {
        name: "Qualys",
        description:
          "I am an agent specialized in network security, part of the AI system known as Iron, developed by 'MJV Technology & Innovation'. My role is to help you identify, fix, and prevent vulnerabilities in your network, ensuring that your systems and data are secure and protected against threats.",
      },
    },
    alerts: {
      updateInProgress: {
        title: "Update in Progress!",
        message:
          "Iron is undergoing updates and may be temporarily unavailable. Thank you for your understanding!",
      },
    },
    common: {
      close: "Close",
    },
    history: {
      title: "Chat History",
      description: "Access the history of conversations with one of our agents.",
      searchForName: "Search by title:",
      searchForNamePlaceholder: "Enter the title...",
      searchFor: "Filter by:",
      allAgents: "All agents",
      tableAgent: "Agent",
      tableTitle: "Title",
      tableDate: "Date",
      tableAction: "Actions",
      reopenChat: "Reopen Chat",
      edit: "Edit",
      remove: "Remove",
      chatNameGeral: "General",
      chatNameUserHistory: "User Story",
      chatNameBacklog: "Backlog",
      chatNameDev: "Development",
      chatNameTestCase: "Test Cases",
      chatNameQA: "QA",
      chatNameSwagger: "Swagger",
      chatNameVulnerability: "Vulnerabilities",
      chatNameFortify: "Fortify",
      chatNameAccessibility: "Accessibility",
      chatNameSupportAbs: "Bradesco Saúde",
      chatNameSupport: "Support",
      chatNameFunctionPoint: "Function Point",
      backendGetDataError: "Error fetching data from backend:",
      erroToLoadData: "Error loading data",
      editHistoryModalTitle: "Edit history title",
      editHistoryModalInputPlaceholder: "Enter new name",
      editHistoryModalSave: "Save",
      editHistoryModalCancel: "Cancel",
      editHistoryModalSucess: "Title updated successfully!",
      editHistoryErroToUpdateTitle: "Error updating title:",
      editHistoryErroToUpdateAgentName: "Error updating agent name.",
      removeHistoryTitle: "You are sure?",
      removeHistoryAlert: "You won't be able to reverse this!",
      removeHistoryConfirm: "Yes, remove!",
      removeHistoryCancel: "Cancel",
      removeHistoryError: "Error removing agent:",
      removeHistorySuccess: "Successfully removed!",
      noDataMessage: "No data to display",
    },
    maintenanceAlert: {
      "title": "Scheduled Maintenance Notice",
      "greeting": "Dear user",
      "message": "We inform you that the MJV Iron platform will be temporarily unavailable for a system update. The interruption will occur from 11/05, with the expected return on 11/06.",
      "importance": "This update is essential to improve the security and performance of the platform, offering an even better experience for you.",
      "request": "We ask that you organize your activities to avoid impacts during this period.",
      "thankYou": "We appreciate your understanding and we are available for any questions."
    },
  }
}